import { SalesOrderContractTaskDocument } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1730. 受注案件契約タスクファイル登録
 * [POST] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  name: string;
  file?: string;
  url?: string;
};

const createSalesOrderContractTaskDocument = (props: Props): Promise<SalesOrderContractTaskDocument> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_documents`,
    props
  );
};

export const useCreateSalesOrderContractTaskDocument = () => {
  return useMutation({
    mutationFn: createSalesOrderContractTaskDocument
  });
};